import type { Translations } from "../types";

const da: Translations = {
  "meta.title": "Klik pr. land-kort",
  "meta.description":
    "Interaktivt verdenskort: gratis klik pr. land samt betalt støtte via Stripe, PayPal og Buy Me a Coffee.",

  "app.title": "Klik pr. land-kort",

  "map.intro":
    "Klik på et land på kortet for at give det en gratis stemme, eller send det økonomisk støtte - begge dele tæller med i den samlede rangliste nedenfor. Kortet afspejler kun støtte inden for denne app, ikke landets faktiske velstand eller BNP.",
  "map.verifying": "Verificerer …",
  "map.confirmNotRobot": "Før du kan tilføje gratis klik, skal du lige bekræfte, at du ikke er en robot:",
  "map.tryAgain": "Prøv igen",
  "map.registeringClick": "Registrerer klik …",
  "map.selectedCountry": "Valgt land: {name}.",
  "map.selectFirstFeedback": "Land valgt. For at tilføje et gratis klik skal du først bekræfte nedenfor, at du ikke er en robot.",
  "map.verificationExpired": "Verificeringen er udløbet - bekræft igen, at du ikke er en robot.",
  "map.slowDown": "Lidt langsommere - vent et øjeblik før dit næste klik.",
  "map.clickFailed": "Klikket kunne ikke registreres. Prøv venligst igen.",
  "map.clickErrorGeneric": "Fejl ved registrering af klik.",
  "map.leaderboardHeading": "Landerangliste",
  "map.emptySelection": "Vælg et land på kortet for at klikke på det eller støtte det.",
  "map.loadingData": "Indlæser data …",

  "worldmap.loadError": "Kortet kunne ikke indlæses.",
  "worldmap.resetZoom": "Nulstil zoom",
  "worldmap.resetButton": "⤾ Nulstil",
  "worldmap.loadingMap": "Indlæser kort …",
  "worldmap.unknownCountry": "Ukendt",
  "worldmap.ariaClicks": "{name}: {clicks} klik",
  "worldmap.tooltipClicks": "{clicks} klik",

  "legend.fewer": "Færre klik",
  "legend.more": "Flere klik",

  "list.empty": "Ingen klik endnu. Vær den første!",
  "list.ariaLabel": "Landerangliste efter klik",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY er ikke angivet - se README for konfiguration.",
  "human.verificationFailedGeneric": "Verificering mislykkedes.",
  "human.networkError":
    "Kunne ikke oprette forbindelse til verificering (netværksfejl) - tjek VITE_SUPABASE_URL, at verify-human er udrullet, og ALLOWED_ORIGIN; se README/NAVODILA.",
  "human.verificationFailedRetry": "Verificering mislykkedes, prøv igen.",

  "provider.stripe": "💳 Kort (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Valgt land",
  "panel.currentlyRanked": "Aktuelt placeret som #{rank}",
  "panel.shareCopied": "Kopieret ✓",
  "panel.shareShared": "Delt ✓",
  "panel.shareButton": "🔗 Del",

  "panel.tableClicks": "Klik",
  "panel.tableFree": "Gratis",
  "panel.tablePaid": "Betalt",
  "panel.rowAllTime": "Samlet",
  "panel.rowThisYear": "I år",
  "panel.rowThisWeek": "Denne uge",
  "panel.rowToday": "I dag",

  "panel.totalCombined": "Samlet i alt:",
  "panel.totalSupport": "Samlet støtte:",

  "panel.paymentMethod": "Betalingsmetode",
  "panel.noPaymentMethod": "Der er i øjeblikket ingen betalingsmetode tilgængelig.",
  "panel.supportAmount": "Støttebeløb (EUR)",
  "panel.amountRange": "Beløbet skal være mellem {min} og {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Estimerede betalte klik:",
  "panel.ratioInfo":
    "Forhold: {a} = {b} klik (f.eks. {c} = {d} klik). Dette er kun et estimat før betaling - det endelige antal klik beregnes og bekræftes altid af serveren ud fra den betaling, der faktisk er bekræftet.",
  "panel.preparing": "Forbereder …",
  "panel.continueWith": "Fortsæt med {provider}",
  "panel.choosePaymentMethod": "Vælg en betalingsmetode",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME er ikke angivet - se README for konfiguration.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID er ikke angivet - se README for konfiguration.",

  "panel.paypalAmountInfo": "Beløb: {amount} (estimeret {clicks} klik). Fuldfør betalingen med PayPal-knappen nedenfor.",
  "panel.back": "← Tilbage",

  "panel.bmcWarningTitle": "⚠️ Før du fortsætter til BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Indsæt koden nedenfor i besked-/notefeltet ved kassen — det er den eneste måde, vi kan se, hvilket land du støtter. Uden koden kan vi ikke tilknytte betalingen til et land.",
  "panel.copy": "Kopiér",
  "panel.copied": "Kopieret ✓",
  "panel.suggestedAmount": "Foreslået beløb:",
  "panel.bmcAmountNote":
    "(estimeret {clicks} klik). BuyMeCoffee understøtter desværre ikke overførsel af beløbet via link — indtast/vælg det selv på deres side. Det faktiske antal klik beregnes altid ud fra det beløb, du rent faktisk sender på BuyMeCoffee, ikke ud fra dette estimat.",
  "panel.openBmc": "Åbn BuyMeCoffee og fortsæt →",
  "panel.waitingProvider": "Venter på betalingsbekræftelse fra betalingsudbyderen …",
  "panel.waitingConfirmation": "Venter på betalingsbekræftelse …",
  "panel.timedOut":
    "Tjekket fik timeout. Hvis du gennemførte betalingen, opdateres kortet, når serveren modtager bekræftelsen - det kan nogle gange tage lidt længere tid.",
  "panel.checkAgain": "Tjek igen",

  "panel.cancelled": "Betalingen blev annulleret eller gennemførtes ikke. Kortet er ikke ændret.",
  "panel.tryAgain": "Prøv igen",

  "panel.confirmed": "✅ Støtte bekræftet!",
  "panel.confirmedBody": "{country} modtog {clicks} betalte klik for {amount}.",

  "panel.errorPreparingSupport": "Fejl ved forberedelse af din støtte.",
  "panel.errorPreparingPayment": "Fejl ved forberedelse af betaling.",
  "panel.errorConfirmingPayment": "Fejl ved bekræftelse af betaling.",
  "panel.errorPayingPaypal": "Fejl ved betaling med PayPal.",

  "share.unranked": "{flag}{country} har brug for din støtte på verdenskortet!\nHjælp landet op ad ranglisten 👇",
  "share.rank1": "{flag}{country} ligger i øjeblikket som #1!\nHjælp os med at blive på toppen 👇",
  "share.rankN": "{flag}{country} ligger i øjeblikket som #{rank}!\nHjælp os med at nå #1 👇",

  "language.switcherLabel": "Sprog",
};

export default da;
